module.exports = __webpack_public_path__ + "img/wlzg-banner2.26b94889.png";